'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('../../../../dist-es6/client/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const PointPlotterDirective=require('../../../../dist-es6/client/directives/plotting/pointPlotterDirective');let

SvgPlotterDirective=function(_PointPlotterDirectiv){_inherits(SvgPlotterDirective,_PointPlotterDirectiv);function SvgPlotterDirective(){_classCallCheck(this,SvgPlotterDirective);return _possibleConstructorReturn(this,_PointPlotterDirectiv.apply(this,arguments))}_createClass(SvgPlotterDirective,[{key:'textBindings',get:function()
{
return['svg'].concat(_toConsumableArray(_PointPlotterDirectiv.prototype.textBindings));
}},{key:'objectBindings',get:function()

{
return['verticalAxis','pointRadius','tooltipText'].concat(_toConsumableArray(_PointPlotterDirectiv.prototype.objectBindings));
}},{key:'controller',get:function()

{
return SvgPlotterController;
}}]);return SvgPlotterDirective}(PointPlotterDirective);let


SvgPlotterController=function(_PointPlotterDirectiv2){_inherits(SvgPlotterController,_PointPlotterDirectiv2);_createClass(SvgPlotterController,null,[{key:'$inject',get:function()
{
return['$scope','$element','$compile'];
}}]);

function SvgPlotterController($scope,$element,$compile){_classCallCheck(this,SvgPlotterController);var _this2=_possibleConstructorReturn(this,
_PointPlotterDirectiv2.call(this,$scope,$element,$compile));

_this2.hitAreaWidth=_this2.pointRadius*2;
_this2._iconHeight=_this2.pointRadius*4;return _this2;
}SvgPlotterController.prototype.

_getPointInfos=function _getPointInfos(times){var _this3=this;
return times.map(function(_ref,index){let{time:time,tooltipText:tooltipText}=_ref;return{
time:time,
index:index,
x:_this3.horizontalAxis.scale(time.getTime()),
y:_this3.plotArea.graphAreaDimensions.height/2,
tooltipText:tooltipText}});

};SvgPlotterController.prototype.

_getHitAreaInfos=function _getHitAreaInfos(){var _this4=this;
const halfPointHeight=this._iconHeight/2;

const getYPos=function(_ref2){let{y:y}=_ref2;return _this4.plotArea.graphAreaBoundaries.top};
const getHeight=function(_ref3){let{y:y}=_ref3;return _this4.plotArea.graphAreaDimensions.height};

return{
x:function(_ref4){let{x:x}=_ref4;return x-_this4.pointRadius},
y:getYPos,
width:this.hitAreaWidth,
height:getHeight,
fill:'transparent',
class:this.class};

};SvgPlotterController.prototype.

_precompileStep=function _precompileStep(d3Selection){var _this5=this;
d3Selection.selectAll('image').
data(this._getPointInfos(this.points)).
enter().
append('image').
attr({
"xlink:href":this.svg,
width:this.pointRadius*2,
height:this.pointRadius*2,
x:function(_ref5){let{x:x}=_ref5;return x-_this5.pointRadius},
y:function(_ref6){let{y:y}=_ref6;return y-_this5.pointRadius}}).

style('pointer-events','none');
};return SvgPlotterController}(PointPlotterDirective.Controller);


module.exports=SvgPlotterDirective;
//# sourceMappingURL=svgPlotterDirective.js.map
